import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const ChevronLeftMD: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper aria-label="Chevron Left Md Icon" viewBox={viewBox} size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.915 7.17693C14.2364 6.92398 14.7106 6.94236 15.0102 7.23141C15.3097 7.52046 15.3288 7.97805 15.0666 8.28813L15.0102 8.34775L11.2251 12L15.0102 15.6523L15.0666 15.7119C15.3288 16.022 15.3097 16.4795 15.0102 16.7686C14.7106 17.0576 14.2364 17.076 13.915 16.8231L13.8532 16.7686L9.48964 12.5582C9.17012 12.2499 9.17012 11.7501 9.48964 11.4418L13.8532 7.23141L13.915 7.17693Z"
      fill={color}
    />
  </SvgWrapper>
)

export default ChevronLeftMD
